//Layouts
import AuthLayout from "../layouts/Auth";
import MainLayout from "../layouts/Main";
import PlanLayout from "../layouts/Plan";
import PhotoEditorLayout from "../layouts/PhotoEditor";
import PlaceDetectorLayout from "../layouts/PlaceDetector";

//Pages
import Home from "../pages/Scene/Home_New";
import Plans from "../pages/Plans";
import Plan from "../pages/Plans/plan";
import SignUp from "../pages/SignUp";
import SignIn from "../pages/SignIn";
import ForgotPassword from "../pages/ForgotPassword";
import PhotoEditor from "../pages/PhotoEditor";
import PlaceDetector from "../pages/PlaceDetector";
import PaymentLayout from "../layouts/Payment";
import Cart from "../pages/Payment/Cart/Cart";
import Payment from "../pages/Payment/Index";
import PaymentResult from "../pages/Payment/Result/PaymentResult";

export const PublicRoutes = [
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
    layout: AuthLayout
  },
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
    layout: AuthLayout
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    layout: AuthLayout
  },
];

export const PrivateRoutes = [
  {
    path: "/app",
    name: "Home",
    component: Home,
    layout: MainLayout
  },
  {
    path: "/",
    name: "Plans",
    component: Plans,
    layout: PlanLayout
  },
  {
    path: "/plan/:id",
    name: "Plan",
    component: Plan,
    layout: PlanLayout,
    layoutProps: {
      isCustomProfile: true
    }
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
    layout: PaymentLayout,
  },
  {
    path: "/payment",
    name: "Payment",
    component: Payment,
    layout: PaymentLayout,
  },
  {
    path: "/payment/result",
    name: "PaymentResult",
    component: PaymentResult,
    layout: PaymentLayout,
  },
  {
    path: "/PhotoEditor",
    name: "PhotoEditor",
    component: PhotoEditor,
    layout: PhotoEditorLayout
  },
  {
    path: "/PlaceDetector/:id",
    name: "PlaceDetector",
    component: PlaceDetector,
    layout: PlaceDetectorLayout
  }
];
